exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-recipient-view .recipient-name {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 3rem;\n}\n\n", ""]);

// exports
